import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../App";
import { useQuery } from "@tanstack/react-query";
import api from "../api";
import {
  HiChevronDown,
  HiChevronUp,
  HiTrash as TrashIcon,
} from "react-icons/hi2";

export default function CartSummary({
  subtotal,
  charges,
  discounts,
  onCheckout,
  orderId,
}) {
  const { user, setUser } = useContext(UserContext);
  const chargesTotal = charges?.reduce((sum, c) => sum + c.amount, 0);
  const discountTotal = discounts?.reduce((sum, d) => sum + d.amount, 0);
  const [showCouponDropdown, setShowCouponDropdown] = useState(false);
  const [couponApplied, setCouponApplied] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [couponId, setCouponId] = useState(0);
  const [discountId, setDiscountId] = useState(0);
  const [discount, setDiscount] = useState(0);

  const {
    data: allCoupons,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["coupons", user?._id],
    enabled: !!user,
    refetchOnWindowFocus:false,
    queryFn: async () => {
      const res = await api.getCoupons(user._id);
      const enriched = res.map((coupon) => {
        const isExpired = new Date(coupon.expiry) < new Date();
        const isUsed = coupon.isUsed;
        const isMinNotMet =
          coupon.minCartValue > 0 && subtotal < coupon.minCartValue;
        let status = "available";
        if (isExpired) status = "expired";
        else if (isUsed) status = "used";
        else if (isMinNotMet) status = "minValueNotMet";
        return { ...coupon, status };
      });
      console.log("enriched coupons", enriched);
      return enriched;
    },
  });

  const handleApplyCoupon = async (coupon_id) => {
    try {
      const couponDetails = {
        id: coupon_id,
        code: couponCode,
        total: Number(subtotal),
        userId: user._id,
        qty: 1,
      };
      const res = await api.validateCoupon(couponDetails);

      console.log("coupon validate", res);

      if (res.discountAmount) {
        const discountAmount = res.discountAmount;
        setDiscount(discountAmount);
        setCouponApplied(true);
      }
    } catch (err) {
      console.log(err);
      alert(err.response?.data?.msg || "Invalid coupon error");
    }
  };

  return (
    <div className="col-12 col-lg-4 col-md-5">
      {/* card */}
      <div className="mb-5 card mt-6">
        <div className="card-body p-6">
          {/* heading */}
          <h2 className="h5 mb-4">Summary</h2>
          <div className="card mb-2">
            {/* list group */}
            <ul className="list-group list-group-flush">
              {/* list group item */}
              <li className="list-group-item d-flex justify-content-between align-items-start">
                <div className="me-auto">
                  <div>Item Subtotal</div>
                </div>
                <span>₹{subtotal}</span>
              </li>
              {/* list group item */}
              {/* {charges?.map((charge) => (
                <li className="list-group-item d-flex justify-content-between align-items-start">
                  <div className="me-auto">
                    <div>{charge.name}</div>
                  </div>
                  <span className="fw-medium">₹{charge.amount.toFixed(2)}</span>
                </li>
              ))}

              {discounts?.map((discount) => (
                <li className="list-group-item d-flex justify-content-between align-items-start">
                  <div className="me-auto">
                    <div>{discount.name}</div>
                  </div>
                  <span>-₹{discount.amount}</span>
                </li>
              ))}

              {couponApplied && (
                  <div className="flex justify-between text-green-700">
                  <span>Coupon Discount</span>
                  <span>- ₹{discount.toFixed(2)}</span>
                </div>
              )}

              {couponApplied && (
              <div className="flex items-center justify-between mt-2">
                <p className="text-sm text-green-600">
                Applied Coupon: <strong>{couponCode}</strong>
                </p>
                <button
                onClick={() => {
                  setCouponApplied(false);
                  setCouponCode("");
                  setDiscount(0);
                  setCouponId(0);
                  setDiscountId(0);
                  // toast("Coupon removed.");
                }}
                className="text-xs text-red-500 underline"
                >
                Remove
                </button>
              </div>
              )} */}

              {/* Charges */}
                {charges?.map((charge) => (
                  <li
                    key={charge.id || charge.name}
                    className="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <span>{charge.name}</span>
                    <span className="fw-medium">₹{charge?.amount.toFixed(2)}</span>
                  </li>
                ))}

                {/* Discounts */}
                {discounts?.map((discount) => (
                  <li
                    key={discount.id || discount.name}
                    className="list-group-item d-flex justify-content-between align-items-center text-success"
                  >
                    <span>{discount.name}</span>
                    <span>- ₹{discount.amount.toFixed(2)}</span>
                  </li>
                ))}

                {/* Coupon Discount */}
                {couponApplied && (
                  <li className="list-group-item bg-success-subtle">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <div className="fw-semibold text-success">
                          <i className="bi bi-ticket-perforated me-2"></i>
                          Coupon Discount
                        </div>
                        <small className="text-muted">
                          Applied: <strong>{couponCode}</strong>
                        </small>
                      </div>

                      <div className="text-end">
                        <div className="fw-bold text-success">
                          - ₹{discount.toFixed(2)}
                        </div>

                        <button
                          className="btn btn-link btn-sm text-danger p-0 mt-1"
                          onClick={() => {
                            setCouponApplied(false);
                            setCouponCode("");
                            setDiscount(0);
                            setCouponId(0);
                            setDiscountId(0);
                          }}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </li>
                )}

              {/* list group item */}
              <li className="list-group-item d-flex justify-content-between align-items-start">
                <div className="me-auto">
                  <div className="fw-bold">Total</div>
                </div>
                <span className="fw-bold">
                  ₹
                  {(Number(subtotal) +
                    Number(chargesTotal) -
                    Number(discountTotal) -
                    Number(discount))?.toFixed(2)
                  }
                </span>
              </li>
            </ul>
          </div>

          <div className="card border-0 shadow-sm mt-4">
            <div className="card-body">
              <h5 className="mb-3 fw-bold">
                <i className="bi bi-ticket-perforated me-2 text-success"></i>
                Apply Coupon
              </h5>

              {/* Coupon Input */}
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter coupon code"
                  value={couponCode}
                  onChange={(e) => setCouponCode(e.target.value)}
                />

                <button
                  className="btn btn-success px-4"
                  onClick={() => handleApplyCoupon(couponId)}
                >
                  Apply
                </button>
              </div>

              {/* Available Coupons Toggle */}
              <button
                className="btn btn-light w-100 d-flex justify-content-between align-items-center border"
                onClick={() => setShowCouponDropdown((prev) => !prev)}
              >
                <span className="fw-medium">Available Coupons</span>

                {showCouponDropdown ? (
                  <HiChevronUp size={18} />
                ) : (
                  <HiChevronDown size={18} />
                )}
              </button>

              {/* Coupon List */}
              {showCouponDropdown && (
                <div className="mt-3">
                  {allCoupons.filter((c) => c.status === "available").length ===
                  0 ? (
                    <div className="alert alert-light mb-0">
                      No available coupons
                    </div>
                  ) : (
                    allCoupons
                      .filter((c) => c.status === "available")
                      .map((coupon) => (
                        <div
                          key={coupon.id}
                          className={`border rounded p-3 mb-2 ${
                            couponCode === coupon.name
                              ? "border-success bg-light"
                              : ""
                          }`}
                        >
                          <div className="d-flex justify-content-between align-items-start">
                            <div>
                              <h6 className="mb-1 fw-bold text-success">
                                {coupon.name}
                              </h6>

                              <small className="text-muted">
                                {coupon.couponDesc}
                              </small>
                            </div>

                            {/* <small className="badge bg-success mt-2">
                              {coupon.discountType == "percentage"
                                ? `${coupon.value}% OFF`
                                : `₹${coupon.value} OFF`}
                            </small> */}

                            <button
                              className={`btn btn-sm ${
                                couponCode === coupon.name
                                  ? "btn-success"
                                  : "btn-outline-success"
                              }`}
                              onClick={() => {
                                setCouponCode(coupon.name);
                                setCouponId(coupon.id);
                                setDiscountId(coupon.discountId);
                                setCouponApplied(false);
                                setDiscount(0);
                                setShowCouponDropdown(false);
                              }}
                            >
                              {couponCode === coupon.name
                                ? "Selected"
                                : "Select"}
                            </button>
                          </div>
                        </div>
                      ))
                  )}
                </div>
              )}
            </div>
          </div>

          {user ? (
            <Link to={`/ShopCheckOut?order_id=${orderId}`}>
              <div className="d-grid mb-1 mt-4">
                {/* btn */}
                <button
                  className="btn btn-primary btn-lg d-flex justify-content-between align-items-center"
                  type="submit"
                  disabled={!user}
                  onClick={onCheckout(discount,chargesTotal)}
                >
                  Go to Checkout <span className="fw-bold"></span>
                </button>
              </div>
            </Link>
          ) : (
            <div className="d-grid mb-1 mt-2">
              {/* btn */}
              <button
                className="btn btn-primary btn-lg d-flex justify-content-between align-items-center"
                type="submit"
                disabled={!user}
              >
                Login to Checkout <span className="fw-bold">₹{subtotal}</span>
              </button>
            </div>
          )}
           {/* text */}
          <div className="mt-2">
            <small>
              By placing your order, you agree to be bound by the Freshcart{" "}
              <Link to="#!">Terms of Service</Link>
              and <Link to="#!">Privacy Policy.</Link>{" "}
            </small>
          </div>
        </div>
      </div>
    </div>
  );
}
